import { useMemo } from 'react'
// import { getGetSpacePricesQueryKey } from '@cocoonspace/sdk-js/domains/availabilities/availabilities'
import { Plural, useLingui } from '@lingui/react/macro'
// import { useQueryClient } from '@tanstack/react-query'

import { Price } from '~/components/price'
// import { useCreateBookingOptions } from '~/domains/booking/hooks/use-create-booking-options.hook'
import { AddToCartButton } from '~/domains/cart/add-to-cart-button'
// import { useExperiment } from '~/hooks/use-experiment'
// import { useAuth } from '~/providers/auth-provider'
import { useMultidatesContext } from './provider'

const BookingOptionsCount = ({ count }: { count: number }) => (
	<div className='flex flex-row justify-between gap-x-1'>
		<div>
			<Plural
				value={count}
				_0='Aucune journée sélectionnée'
				one='# journée sélectionnée'
				other='# journées sélectionnées'
			/>
		</div>
	</div>
)

const DiscountedPrices = ({
	price_day,
	price_day_discounted,
}: {
	price_day?: number
	price_day_discounted?: number
}) => {
	const { t } = useLingui()

	return (
		<div className='flex flex-row items-center gap-1 text-sm'>
			{t`soit`}

			<Price
				className='font-normal'
				crossed
				price={price_day}
			/>

			<Price
				className='text-primary'
				price={price_day_discounted}
			/>
		</div>
	)
}

export const StepMultidateFooter = () => {
	// const router = useRouter()
	// const queryClient = useQueryClient()
	// const hasCartXp = useExperiment('carts-beta')
	// const { isAuth, openRegister, setAuthErrorMsg } = useAuth()
	// const { t } = useLingui()

	const { space, bookingDays, setBookingDays, pricesQuery } =
		useMultidatesContext()

	// const { mutateAsync: createBooking } = useCreateBookingOptions()

	const totalPrices = useMemo(() => {
		return bookingDays.reduce<{
			price_day?: number
			price_day_discounted?: number
		}>(
			(acc, day) => {
				if (!pricesQuery.data?.pricesByDay[day]) return acc

				const { price_day_discounted, price_day } =
					pricesQuery.data?.pricesByDay[day] || {}

				return {
					price_day:
						price_day !== undefined
							? (acc.price_day || 0) + price_day
							: undefined,
					price_day_discounted:
						price_day_discounted !== undefined
							? (acc.price_day_discounted || 0) + price_day_discounted
							: undefined,
				}
			},
			{ price_day: undefined, price_day_discounted: undefined },
		)
	}, [bookingDays, pricesQuery.data?.pricesByDay])

	const hasDiscount =
		totalPrices?.price_day !== undefined &&
		totalPrices?.price_day_discounted !== undefined &&
		totalPrices?.price_day !== totalPrices?.price_day_discounted

	// const handleSubmit = async () => {
	// 	if (space.status !== 'published') return
	//
	// 	if (!isAuth) {
	// 		router.push(
	// 			{
	// 				query: {
	// 					...router.query,
	// 					day: bookingDays,
	// 				},
	// 			},
	// 			undefined,
	// 			{ shallow: true },
	// 		)
	//
	// 		setAuthErrorMsg(t`Vous devez être connecté(e) pour réserver un Cocoon`)
	// 		openRegister()
	// 		return
	// 	}
	//
	// 	const payload = {
	// 		bookingOptions: bookingDays.map((day) => ({ day })),
	// 		space,
	// 	}
	//
	// 	return createBooking(payload)
	// 		.then(({ id }) => {
	// 			router.push({
	// 				pathname: '/booking/[bookingId]/payment',
	// 				query: {
	// 					...router.query,
	// 					bookingId: id,
	// 				},
	// 			})
	// 		})
	// 		.catch((err) => {
	// 			// * remove unavailable bookingOptions
	// 			const toDisable = payload.bookingOptions
	// 				.filter(({ day }) => !err.data.some((e: any) => e.day === day))
	// 				.map(({ day }) => day)
	//
	// 			setBookingDays(toDisable)
	//
	// 			// * invalidate calendar prices to reset unavailable days
	// 			queryClient.invalidateQueries({
	// 				queryKey: getGetSpacePricesQueryKey(space.id),
	// 			})
	//
	// 			toast.error(
	// 				err.message === 'unavailable'
	// 					? t`Certains dates sélectionnées ne sont plus disponibles et ont été retirées de votre sélection.`
	// 					: t`Une erreur est survenue`,
	// 			)
	// 		})
	// }

	return (
		<div className='flex min-h-[93px] flex-col justify-between border-t border-slate-200 p-4'>
			<BookingOptionsCount count={bookingDays.length} />

			<div className='flex flex-row items-end justify-between'>
				<div className='flex flex-col'>
					<div className='flex'>
						{hasDiscount && <DiscountedPrices {...totalPrices} />}
					</div>

					<Price
						className='mt-auto flex flex-row text-2xl leading-tight'
						price={
							totalPrices?.price_day_discounted !== undefined
								? totalPrices?.price_day_discounted
								: totalPrices?.price_day
						}
						taxClassName='mb-[4px] text-xxs'
						taxType='ht'
					/>
				</div>

				<div className='flex items-center gap-x-2'>
					{/* previously gated: {hasCartXp ? <AddToCartButton .../> : <Button ...>Réserver</Button>} */}
					<AddToCartButton
						bookingOptions={bookingDays.map((day) => ({ day }))}
						onSuccess={() => setBookingDays([])}
						space={space}
					/>
				</div>
			</div>
		</div>
	)
}
